

define(['angular', 'squid/index', './directive'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-bml-apply.route', ['squid', 'xo-bml-apply.directive']).factory('$BmlApplyRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('BmlApplyRoute', {

            name: 'bmlapply',
            trackingData: {
                fptiState: 'ppc_apply'
            },
            directive: 'xo-bml-apply-page',
            titleContent: 'applyForBml.bmlApplyHeadline',

            children: []

        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-credit-components/src/bml-display/xo-bml-apply/route.js
// module id = ./components/xo-credit-components/src/bml-display/xo-bml-apply/route.js
// module chunks = 1